/* eslint-disable no-useless-constructor */
/* eslint-disable prefer-template */
import { CallEvent } from '@byted/tiktok-zti-call';
import { EventErrorParams } from '@byted/tiktok-zti-types';
import { getLevel2domain } from '../utils/cookie';

class DocCookie extends CallEvent<{
  error: EventErrorParams;
}> {
  constructor() {
    super();
  }

  getCookie = (key: string) => {
    try {
      const value =
        decodeURIComponent(
          document.cookie.replace(
            new RegExp(
              '(?:(?:^|.*;)\\s*' +
                encodeURIComponent(key).replace(/[-.+*]/g, '\\$&') +
                '\\s*\\=\\s*([^;]*).*$)|^.*$'
            ),
            '$1'
          )
        ) || null;
      return value;
    } catch (error) {
      this.emit('error', { error, name: 'cookie get item error' });
    }
    return null;
  };

  setCookie = (
    key: string,
    value: string,
    path: string,
    domain?: string,
    maxAge?: number,
    secure?: boolean
  ) => {
    try {
      if (!key || /^(?:expires|max\-age|path|domain|secure)$/i.test(key)) {
        return false;
      }
      document.cookie =
        encodeURIComponent(key) +
        '=' +
        encodeURIComponent(value) +
        (maxAge ? '; max-age=' + maxAge : '') +
        (domain ? '; domain=' + domain : '') +
        (path ? '; path=' + path : '') +
        (secure ? '; secure' : '');
      return true;
    } catch (error) {
      this.emit('error', { error, name: 'cookie set item error' });
    }
    return false;
  };

  setCookieNoTimeout = (key: string, value: string) => {
    // const currentDomain = document.location.hostname;
    this.setCookie(key, value, '/');
  };

  setCookieWithMaxAge = (key: string, value: string) => {
    // const currentDomain = document.location.hostname;
    this.setCookie(key, value, '/', undefined, 5184000);
  };

  setCookieWithDomain = (key: string, value: string) => {
    const domain = getLevel2domain();
    this.setCookie(key, value, '/', domain, 5184000);
  };

  deleteCookie = (key: string, path: string, domain?: string) => {
    if (!key || !this.hasCookie(key)) {
      return false;
    }
    document.cookie =
      encodeURIComponent(key) +
      '=; expires=Thu, 01 Jan 1970 00:00:00 UTC' +
      (domain ? '; domain=' + domain : '') +
      (path ? '; path=' + path : '');
    return true;
  };

  deleteAllCookie = (key: string) => {
    const domain = getLevel2domain();
    const currentDomain = document.location.hostname;
    this.deleteCookie(key, '/', domain);
    this.deleteCookie(key, '/', currentDomain);
    this.deleteCookie(key, '/');
  };

  hasCookie = (key: string) => {
    return new RegExp('(?:^|;\\s*)' + encodeURIComponent(key).replace(/[-.+*]/g, '\\$&') + '\\s*\\=').test(
      document.cookie
    );
  };

  getCookieKeys = () => {
    let aKeys = document.cookie
      .replace(/((?:^|\s*;)[^\=]+)(?=;|$)|^\s*|\s*(?:\=[^;]*)?(?:\1|$)/g, '')
      .split(/\s*(?:\=[^;]*)?;\s*/);

    let keys = [];
    for (let nIdx = 0; nIdx < aKeys.length; nIdx++) {
      // aKeys[nIdx] = decodeURIComponent(aKeys[nIdx]);
      if (aKeys[nIdx]) {
        keys.push(decodeURIComponent(aKeys[nIdx]));
      }
    }
    return keys;
  };
}

export default DocCookie;
